//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InfiniteLoading from 'vue-infinite-loading'
import { mapGetters } from 'vuex'
import breakpointMixin from '~/mixins/breakpointMixin'

export default {
  components: {
    InfiniteLoading
  },
  mixins: [breakpointMixin],
  props: {
    rows: { type: Number, default: 2 },
    extraRowStep: { type: Number, default: 4 },
    autoLoadMore: { type: Boolean, default: false }
  },
  data: () => ({
    extraRows: 0,
    activePostId: 0
  }),
  async fetch () {
    await this.$store.dispatch('insta/GET')
  },
  computed: {
    ...mapGetters({
      allPosts: 'insta/posts',
      numberLoaded: 'insta/loaded',
      totalPostCount: 'insta/count'
    }),
    columns () {
      return this.isMdBreakpointOrAbove ? 3 : 2
    },
    limit () {
      return (this.rows + this.extraRows) * this.columns
    },
    posts () {
      return this.allPosts.slice(0, this.limit)
    },
    activePost () {
      if (!this.activePostId) return {}
      return this.posts.find(post => post.id === this.activePostId) || {}
    },
    activePostIdx () {
      return this.posts.findIndex(post => post.id === this.activePostId)
    },
    showPopupPrevious () {
      return this.activePostIdx > 0
    },
    showPopupNext () {
      return this.activePostIdx < this.limit
    }
  },
  methods: {
    async infiniteLoadingCallback (infiniteState) {
      const morePostsAvailable = await this.loadMore()
      if (morePostsAvailable) infiniteState.loaded()
      else infiniteState.complete()
    },
    async loadMore () {
      // If we haven't got enough loaded then load more
      if (this.limit + this.columns * this.extraRowStep > this.numberLoaded) await this.$store.dispatch('insta/GET')

      // Add extra rows
      this.extraRows += this.extraRowStep

      // If we've run out of posts then return false
      if (this.limit >= this.totalPostCount) return false

      // If more posts are available then return true
      return true
    },
    goToNextActivePost () {
      this.activePostId = this.posts[this.activePostIdx + 1].id
    },
    goToPreviousActivePost () {
      this.activePostId = this.posts[this.activePostIdx - 1].id
    }
  }
}
